export default [{
    path: 'cost',
    name:'cost',
    meta: {
        title: '促销费用函'
    },
    component: () =>
      import ( /* webpackChunkName: "pop-cost" */ '../views/promotion/cost.vue')
  },{
    path: 'costDetail',
    name:'costDetail',
    meta: {
        title: '促销费用函详情'
    },
    component: () =>
      import ( /* webpackChunkName: "pop-costDetail" */ '../views/promotion/detail/costDetail.vue')
  },{
    path: 'bill-detail',
    name: 'bill-detail',
    meta: {
      title: '账单明细'
    },
    component: () =>
      import ( /* webpackChunkName: "pop-billDetail" */ '../views/promotion/billDetail.vue')
  },
  {
    path: 'promise',
    name: 'promise',
    meta: {
      title: '促销承诺函'
    },
    component: () =>
      import( /* webpackChunkName: "pop-cost" */ '../views/promotion/promise.vue')
  }, {
    path: 'promiseDetail',
    name: 'promiseDetail',
    meta: {
      title: '促销承诺函详情'
    },
    component: () =>
      import( /* webpackChunkName: "pop-costDetail" */ '../views/promotion/detail/promiseDetail.vue')
  }, {
    path: 'reward-bill',
    name: 'reward-bill',
    meta: {
      title: '账单明细'
    },
    component: () =>
      import( /* webpackChunkName: "pop-rewardBill" */ '../views/promotion/rewardBill.vue')
  },
  {
    name: 'sales-bill',
    meta: {
      title: '购物返现账单明细'
    },
    path: 'sales-bill',
    component: () =>
        import('../views/promotion/salesBill.vue')
  }
]
